/**
 * Main material of package.
 */
export type PackageMainMaterial =
  | 'GLASS'
  | 'METAL'
  | 'ALUMINUM'
  | 'WOOD'
  | 'CORKWOOD'
  | 'PLASTIC'
  | 'PAPER_AND_CARDBOARD'
  | 'CERAMICS'
  | 'VULCANIZED_SOFT_RUBBER'
  | 'PRODUCT_OF_PLANT_ORIGIN_NOT_MENTIONED_ELSEWHERE'
  | 'OTHER';

export const PackageMainMaterial = {
  Glass: 'GLASS' as PackageMainMaterial,
  Metal: 'METAL' as PackageMainMaterial,
  Aluminum: 'ALUMINUM' as PackageMainMaterial,
  Wood: 'WOOD' as PackageMainMaterial,
  Corkwood: 'CORKWOOD' as PackageMainMaterial,
  Plastic: 'PLASTIC' as PackageMainMaterial,
  PaperAndCardboard: 'PAPER_AND_CARDBOARD' as PackageMainMaterial,
  Ceramics: 'CERAMICS' as PackageMainMaterial,
  VulcanizedSoftRubber: 'VULCANIZED_SOFT_RUBBER' as PackageMainMaterial,
  ProductOfPlantOriginNotMentionedElsewhere:
    'PRODUCT_OF_PLANT_ORIGIN_NOT_MENTIONED_ELSEWHERE' as PackageMainMaterial,
  Other: 'OTHER' as PackageMainMaterial,
};
